import { render, staticRenderFns } from "./modalReclamo.vue?vue&type=template&id=c8480ff6&scoped=true"
import script from "./modalReclamo.vue?vue&type=script&lang=js"
export * from "./modalReclamo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8480ff6",
  null
  
)

export default component.exports